<div class="row">
    <div class="col-12 col-md-4">
        <form #f="ngForm" (ngSubmit)="f.valid && submit()" novalidate>
            <div class="page-section">
                <div class="page-section-header">
                    <h2 class="page-section-title">Notification Device</h2>
                </div>
                <div class="page-section-form">
                    <div class="mb-3">
                        <label for="title" class="form-label">Device Title <em>*</em></label>
                        <input type="text" class="form-control form-control-sm" id="title" name="title" #title="ngModel" [(ngModel)]="data.title" required>
                        <div *ngIf="f.submitted && title.invalid" class="invalid-feedback">
                            <div *ngIf="title.errors.required">Title is required</div>
                        </div>
                    </div>
                    <div class="mb-3">
                        <label for="code" class="form-label">Code</label>
                        <div class="d-flex gap-2">
                            <input type="text" class="form-control form-control-sm flex-fill" id="code" name="code" #payee="ngModel" [(ngModel)]="data.code" autocomplete="off" readonly>
                            <button type="button" class="btn btn-outline-primary btn-sm" (click)="newCode()">Generate</button>
                        </div>
                    </div>
                    <button type="submit" class="btn btn-primary btn-sm w-100">Update</button>
                </div>
            </div>
        </form>
    </div>
</div>
